export const faq = [
  {
    id: 1,
    question: "What services does Argyle Consulting offer?",
    answer:
      "We specialise across eight pillars: strategy & management, corporate finance, financial advisory, human resource, risk & compliance, audit, technology & digital, and property consultancy, serving resident and non-resident companies in Nigeria and beyond.",
  },
  {
    id: 2,
    question: "Do you provide customised solutions for businesses?",
    answer:
      "Yes. All our services are tailored to the specific needs and goals of your business, ensuring personalised and impactful outcomes.",
  },
  {
    id: 3,
    question: "Are your services available to international clients?",
    answer:
      "Absolutely. While based in Nigeria, we cater to both resident and non-resident companies and collaborate globally through affiliations and partnerships.",
  },
  {
    id: 4,
    question: "How experienced is your team with complex financial matters?",
    answer:
      "Our team brings decades of experience across industries, offering deep expertise in intricate financial, tax, compliance, and technology challenges.",
  },
  {
    id: 5,
    question: "Can you assist with converting from local GAAP to IFRS?",
    answer:
      "Yes. We have hands-on expertise helping organisations transition from local GAAP to IFRS, ensuring a smooth and compliant process.",
  },
  {
    id: 6,
    question: "How quickly can I expect a response to my enquiry?",
    answer:
      "We are committed to timely responses and strive to address all enquiries within 24 to 48 hours.",
  },
];
